let id = 0
export function useId() {
  ++id

  return id
}
